import React, { useMemo } from "react";
import styled from "@emotion/styled";

type Alignment = "left" | "center" | "right";

interface TextWithBreaksProps {
	text: string | undefined | null;
	align?: Alignment;
	gap?: number;
	className?: string;
}

export const TextWithBreaks = ({ text, align = "center", gap, className }: TextWithBreaksProps): JSX.Element => {
	const lines = useMemo(() => (text ? text.split("\n") : undefined), [text]);

	return lines ? (
		<Container align={align} gap={gap} className={className}>
			{lines.map((line, index) => (
				<div key={`${line}-${index}`}>{line}</div>
			))}
		</Container>
	) : (
		<></>
	);
};

const flexAlignFromAlignment = (alignment: Alignment): "flex-start" | "center" | "flex-end" => {
	switch (alignment) {
		case "left":
			return "flex-start";
		case "center":
			return "center";
		case "right":
			return "flex-end";
	}
};

const Container = styled.div<{ align: Alignment; gap?: number }>`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: ${({ align }) => flexAlignFromAlignment(align)};
	${({ gap }) => gap && `gap: ${gap}px;`}
`;
